import { render, staticRenderFns } from "./pinjam-ruang.vue?vue&type=template&id=0973a35c&"
import script from "./pinjam-ruang.vue?vue&type=script&lang=js&"
export * from "./pinjam-ruang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports